import { initReactI18next } from 'react-i18next';
import { createInstance, type Resource } from 'i18next';

type ClientI18nArgs = {
  fallbackLng?: string;
  lng: string;
  resources: Resource;
};

const clientI18n = createInstance();
let isInitialized = false;

export function getClientI18n({ fallbackLng = 'en-US', lng, resources }: ClientI18nArgs) {
  if (!isInitialized) {
    clientI18n.use(initReactI18next);
    clientI18n.init({
      lng,
      fallbackLng,
      defaultNS: 'label',
      resources,
      react: { useSuspense: false },
      initImmediate: false,
    });
    isInitialized = true;
  } else {
    if (clientI18n.language !== lng) {
      void clientI18n.changeLanguage(lng);
    }

    const languageResources = resources?.[lng];
    if (languageResources) {
      Object.entries(languageResources).forEach(([namespace, bundle]) => {
        clientI18n.addResourceBundle(lng, namespace, bundle, true, true);
      });
    }
  }

  return clientI18n;
}
